import "isomorphic-fetch";
import { Promise } from "es6-promise";

Promise.polyfill();

// SCSS imports
// Theme identity
import "./assets/index";

//Component SCSS files
import "./components";

// Shared JS files
import "../../shared/components/featured-articles/index";
import "../../shared/components/footer/index";
import "../../shared/components/form/index";
import "../../shared/components/header-static/index";
import "../../shared/components/text/index";
import "../../shared/components/variants-block/index";
import "../../shared/components/video/index";
import "../../shared/components/cookie-bar/index";

// Shared JS files
import "./components/search-filter-result/index";
import "./assets/app";
